import { ContactlessOutlined } from "@material-ui/icons";

export function GetKDfromString(pathname) {
    let centro_id = -1, nombre_empresa = "";

    if (pathname.includes("feccoslada")) {
        centro_id = 61; nombre_empresa = "FEC Coslada";
    } else if (pathname.includes("fecbilbao2020")) {
        centro_id = 12; nombre_empresa = "FEC Bilbao 2020";
    } else if (pathname.includes("alcobendasentertainment")) {
        centro_id = 14; nombre_empresa = "Alcobendas Ent.";
    } else if (pathname.includes("albaceteocio2015")) {
        centro_id = 98; nombre_empresa = "Albacete Ocio";
    } else if (pathname.includes("bowlingstation2015")) {
        centro_id = 41; nombre_empresa = "Bowling Station";
    } else if (pathname.includes("bolerabaliak")) {
        centro_id = 43; nombre_empresa = "Bowling Baliak";
    } else if (pathname.includes("boleraxanadu2010")) {
        centro_id = 102; nombre_empresa = "Bolera Xanadu 2010";
    } else if (pathname.includes("bolerarec2000")) {
        centro_id = 96; nombre_empresa = "Bolera REC 2000";
    } else if (pathname.includes("boleralaplana")) {
        centro_id = 99; nombre_empresa = "Bolera La Plana";
    } else if (pathname.includes("bowlinggirones")) {
        centro_id = 56; nombre_empresa = "Bowling Girones";
    } else if (pathname.includes("boleracentrosdejuego")) {
        centro_id = 51; nombre_empresa = "Centros de Juego";
    } else if (pathname.includes("bowlingdaro")) {
        centro_id = 1; nombre_empresa = "Bowling d'Aro";
    } else if (pathname.includes("barnaocio2015")) {
        centro_id = 86; nombre_empresa = "Barna Ocio 2015";
    } else if (pathname.includes("pamplonabowling")) {
        centro_id = 64; nombre_empresa = "Pamplona Bowling";
    } else if (pathname.includes("neuritelab")) {
        centro_id = 0; nombre_empresa = "Neurite Lab";
    }

    return { empresa: nombre_empresa, centro_id: centro_id };
}

export function GetOriginfromPathname() {

    const pathname = window.location.pathname;
    if (pathname.includes("feccoslada")) return ('https://feccoslada.com') ;
    else if (pathname.includes("fecbilbao2020")) return ('https://fecbilbao2020.com') ;
    else if (pathname.includes("alcobendasentertainment")) return ('https://alcobendasentertainment.com') ;
    else if (pathname.includes("albaceteocio2015")) return ('https://albaceteocio2015.com') ;
    else if (pathname.includes("bowlingstation2015")) return ('https://bowlingstation2015.com') ;
    else if (pathname.includes("bolerabaliak")) return ('https://bolerabaliak.com') ;
    else if (pathname.includes("boleraxanadu2010")) return ('https://boleraxanadu2010.com') ;
    else if (pathname.includes("bolerarec2000")) return ('https://bolerarec2000.com') ;
    else if (pathname.includes("boleralaplana")) return ('https://boleralaplana.com') ;
    else if (pathname.includes("bowlinggirones")) return ('https://bowlinggirones.com') ;
    else if (pathname.includes("boleracentrosdejuego")) return ('https://boleracentrosdejuego.com') ;
    else if (pathname.includes("bowlingdaro")) return ('https://bowlingdaro.com') ;
    else if (pathname.includes("barnaocio2015")) return ('https://barnaocio2015.com') ;
    else if (pathname.includes("pamplonabowling")) return ('https://pamplonabowling.com') ;
    else if (pathname.includes("neuritelab")) return ('https://neuritelab.com') ;
    else return ('');
}


export function HasKDpath() {
    return GetKDfromString(window.location.pathname).centro_id !== -1;
}

function hasUserLoggedIn() {
    return window.hasUserKD !== undefined;
}

function comesFromIframe() {
    return window.location.ancestorOrigins[0] !== undefined;
    //fbpkd
    //return true;
}

export function setKDuserLoggedIn() {
    window.hasUserKD = true;
}

export function IsKD_Login() {
    //return (hasKDpath() && !hasUserLoggedIn() && !comesFromIframe()); comentado hasta que funcione hasUserLoggedIn()
    return (HasKDpath() && !comesFromIframe());
}

export function IsKD_Inventario() {
    //return (hasKDpath() && hasUserLoggedIn() && comesFromIframe()); comentado hasta que funcione hasUserLoggedIn()
    return (comesFromIframe());
}

// export function IsTCG_Login()
// {
//     return (!HasKDpath() && ! HasUserLoggedIn() && ! ComesFromIframe());
// }

// export function NonStandardAccess()
// {
//     return (!IsTCG_Login() && !IsKD_Login() && !IsKD_Inventario());
// }

export function SetKD() {
    window.location.kd = window.location.ancestorOrigins[0];
    //fbpkd 
    //window.location.kd = window.location.ancestorOrigins[0] ? window.location.ancestorOrigins[0] : "http://feccoslada.com";
}

export function AfterKDlogin() {
    setKDuserLoggedIn();
}